import { z } from "zod";

/**
 * Payment requirement for a service — determines whether the client must pay
 * upfront, leave a deposit, or can book for free.
 */
export const paymentRequirementSchema = z.enum(["NONE", "DEPOSIT", "FULL"]);
export type PaymentRequirement = z.infer<typeof paymentRequirementSchema>;

/** Matches 3- or 6-digit hex colour strings like `#fff` or `#0F172A`. */
export const HEX_COLOR_REGEX = /^#(?:[0-9a-fA-F]{3}){1,2}$/;
